import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Checkbox } from "react-bootstrap";
import moment from "moment";

import { Bold } from "../Styles";
import {
  getJob as getJobAction,
  getApplicants as getApplicantsAction,
} from "../../redux/middleware/job";
import Loader from "../Shared/Loader";
import { Header, HeaderTitle, ViewButton } from "./Styles/Applicants.style";

const ApplicantTable = ({ applicants }) => (
  <table cellSpacing="0" cellPadding="0" className="table">
    <thead>
      <tr>
        <th />
        <th width="30%">Name</th>
        <th width="20%">Date Applied</th>
        <th className="hidden-xs" width="20%">
          Rating
        </th>
        <th className="hidden-xs" width="20%">
          Active
        </th>
        <th width="20%" />
      </tr>
    </thead>
    <tbody>
      {applicants.map((applicant) => {
        const { user } = applicant;
        return (
          <tr key={applicant?.application?.id}>
            <td />
            <td>
              <Bold>{`${user.fname} ${user.lname}`}</Bold>
            </td>
            <td>
              <i className="fa fa-calendar" />
              &nbsp;
              {moment(user.apply_date).format("MM-DD-YYYY")}
            </td>
            <td className="hidden-xs">
              <i className="fa fa-calendar" />
              &nbsp;Not Rated
            </td>
            <td className="hidden-xs">
              <i className="fa fa-calendar" />
              &nbsp;Active
            </td>
            <td>
              {/* @TODO josiah => make the functionality work */}
              {/* <DeleteButton className="btn_status" onClick={() => this.props.remove(applicant)}>Remove</DeleteButton> */}
              <ViewButton
                to={`/dashboard/jobs/${applicant.application.job_id}/applicants/${applicant.application.profile_id}`}
              >
                View
              </ViewButton>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

class Applicants extends Component {
  constructor(props) {
    super(props);
    this.state = { searchItem: false };
  }

  componentWillMount() {
    const { getJob, jobId } = this.props;
    getJob(jobId, { applicants: true });
  }

  searchStatusVise = (value) => {
    const { getApplicants, job } = this.props;
    this.setState({ searchItem: value });
    getApplicants(job, value ? "rejected" : "");
  };

  render() {
    const { pending, applicants: userApplicants } = this.props;
    const { searchItem } = this.state;
    if (pending || !userApplicants)
      return <Loader fullScreen vwidth="50vw" show />;

    const applicants =
      userApplicants &&
      userApplicants.sort((a, b) => {
        const d1 = new Date(a.user.apply_date);
        const d2 = new Date(b.user.apply_date);
        return d2 - d1;
      });

    return (
      <div className="TabbedPanelsContent">
        <Header>
          <HeaderTitle>Applicants</HeaderTitle>
        </Header>
        <div className="tab_padd recent_job">
          <div className="scrobl_div post">
            <br />
            <br />
            <Checkbox
              style={{ margin: "0 0 0 23px", paddingTop: 44 }}
              onClick={(e) => this.searchStatusVise(e.target.checked)}
              checked={searchItem}
            >
              Show Rejected Applicants?
            </Checkbox>
            <ApplicantTable applicants={applicants} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  applicants: state.applicants.applicants,
  pending: state.applicants.pending,
  job: state.job.job,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getApplicants: getApplicantsAction,
      getJob: getJobAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Applicants);
